import useDebounce from '@tv2/lib-offspring/hooks/useDebounce';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { SearchIntent, setQuery, useSearchQueryInstant } from './searchQueryStore';

export type UpdateSearchQueryOptions = {
  /** Clear any active filters as part of the update. Defaults to `true`. */
  resetFilters?: boolean;
  /** Records how the query was triggered (suggestion/history). */
  intent?: SearchIntent;
};

export type UpdateSearchQuery = (query?: string, options?: UpdateSearchQueryOptions) => void;

export function useUpdateSearchQuery(): UpdateSearchQuery {
  const router = useRouter();

  return useCallback(
    (query, options) => {
      const crossedRoute = setQuery(query, {
        filters: options?.resetFilters === false ? undefined : [],
        intent: options?.intent,
      });

      // Starting or clearing a search moves between the two routes and needs
      // the router. Every keystroke in between is already handled by the
      // store's `replaceState`, which is deliberately invisible to the router.
      if (crossedRoute) {
        router.replace(`${window.location.pathname}${window.location.search}`, { scroll: false });
      }
    },
    [router]
  );
}

export function useSearchQuery(): string {
  const query = useSearchQueryInstant();
  return useDebounce(query, 500);
}

export { useSearchQueryInstant };
